
import React from 'react'
import { Route, Switch } from 'react-router-dom'
import Layout from '../components/Layout'

export default () => (
  <Switch>
    {/*<Route path='/404' key='404' exact component={Page404} />*/}
    <Route path='/' component={Layout} key='app' />
  </Switch>
)